<template>
  <div class="flex flex-row justify-start items-center input-number-fixed bg-border-1">
    <InputNumber
      :model-value="modelValue"
      @change="handleChange"
      :min="min"
      :max="max"
      :precision="precision"
      :step="step"
      :disabled="disabled"
      :hide-button="hideButton"
      class="bg-transparent"
    >
    </InputNumber>
    <slot name="suffix"></slot>
    <!-- {{ min }}:{{ step }}:{{ precision }} -->
  </div>
</template>
<script setup>
import { InputNumber } from '@arco-design/web-vue';
import { getLimitedNumber } from '../InputNumberRange/number.js';
const emits = defineEmits(['update:value']);
const props = defineProps({
  modelValue: {
    type: Number,
    default: 0
  },
  min: {
    type: Number
  },
  max: {
    type: Number
  },
  step: {
    type: Number
  },
  disabled: {
    type: Boolean,
    default: false
  },
  hideButton: {
    type: Boolean,
    default: false
  },
  precision: {
    type: Number,
    default: 0
  }
});
const handleChange = (val) => {
  // 检查左值是否大于右值
  const { min, precision, step } = props;
  val = getLimitedNumber(val, min, step, precision);
  emits('update:modelValue', val);
};
</script>
<style>
.input-number-fixed {
  .arco-input-disabled {
    border: none;
  }
}
</style>
